import React from 'react';
import { ThemeProvider, useTheme } from '../../context/ThemeContext';
import BrandLogo from '../BrandLogo';

const API = process.env.REACT_APP_BACKEND_URL;
const LOGO_URL = "/logo-dark.png";
const GUEST_MSG_LIMIT = 5;

function getAuth() {
  const token = localStorage.getItem('opensov-token');
  const user = JSON.parse(localStorage.getItem('opensov-user') || 'null');
  return { token, user };
}

function getGuestId() {
  let gid = localStorage.getItem('opensov-guest-id');
  if (!gid) { gid = crypto.randomUUID(); localStorage.setItem('opensov-guest-id', gid); }
  return gid;
}

function apiHeaders() {
  const { token } = getAuth();
  const h = { 'Content-Type': 'application/json' };
  if (token) h['Authorization'] = `Bearer ${token}`;
  else h['x-guest-id'] = getGuestId();
  return h;
}

function uploadHeaders() {
  const { token } = getAuth();
  const h = {};
  if (token) h['Authorization'] = `Bearer ${token}`;
  else h['x-guest-id'] = getGuestId();
  return h;
}

function Logo({ size = 'sm', className = '' }) {
  const s = size === 'lg' ? 'h-14' : size === 'md' ? 'h-8' : 'h-7';
  return <BrandLogo className={`${s} ${className}`} />;
}

async function ttsSpeak(text, headers) {
  try {
    const res = await fetch(`${API}/api/voice/tts`, {
      method: 'POST', headers: { ...headers, 'Content-Type': 'application/json' },
      body: JSON.stringify({ text: text.slice(0, 2000), language: 'en-IN' }),
    });
    if (!res.ok) return null;
    const blob = await res.blob();
    const url = URL.createObjectURL(blob);
    const audio = new Audio(url);
    audio.play();
    audio.onended = () => URL.revokeObjectURL(url);
    return audio;
  } catch (e) {
    console.error('TTS error:', e);
    return null;
  }
}

export { API, LOGO_URL, GUEST_MSG_LIMIT, getAuth, getGuestId, apiHeaders, uploadHeaders, ThemeProvider, useTheme, Logo, ttsSpeak };
